import { render, staticRenderFns } from "./SellCoins.vue?vue&type=template&id=087eff1c&scoped=true&"
import script from "./SellCoins.vue?vue&type=script&lang=ts&"
export * from "./SellCoins.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoins.vue?vue&type=style&index=0&id=087eff1c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087eff1c",
  null
  
)

export default component.exports